export class GroupPermissions {
    public static NONE: number = 0;
    public static READAPPROVED: number = 1;
    public static READANY: number = 2;
    public static READWRITE: number = 3;
}

export class GroupCostPermissions {
    public static NONE: number = 0;
    public static READANY: number = 2;
    public static READWRITE: number = 3;
}
